export const TOSS_VIRTUAL_ACCOUNT_BANK_LIST = [
	{ value: '기업', label: 'IBK기업', icon: 'ibk' },
	{ value: '농협', label: 'NH농협', icon: 'nh' },
	{ value: '광주', label: '광주', icon: 'jb' },
	{ value: '경남', label: '경남', icon: 'bnk' }, // 개발 서버에서 테스트 불가
	{ value: '국민', label: '국민', icon: 'kb' },
	{ value: '대구', label: '대구', icon: 'dgb' },
	{ value: '부산', label: '부산', icon: 'bnk' },
	{ value: '새마을금고', label: '새마을금고', icon: 'mg' },
	{ value: '수협', label: '수협', icon: 'sh' },
	{ value: '신한', label: '신한', icon: 'shinhan' },
	{ value: '우리', label: '우리', icon: 'woori' },
	{ value: '우체국', label: '우체국', icon: 'post' },
	{ value: '전북', label: '전북', icon: 'jb' },
	{ value: '케이뱅크', label: '케이뱅크', icon: 'kbank' },
	{ value: '하나', label: '하나', icon: 'hana' },
];

export default null;
